import { useCallback, useEffect, useState } from 'react';

import { findNextPaths } from '../utils';
import { useCurrentPath } from './useCurrentPath';
import { useFlow } from './useFlow';
import { useFlowState } from './useFlowState';
import { useRootPath } from './useRootPath';

export function usePrevSteps(): {
  error?: Error;
  loading: boolean;
  prevSteps: string[];
} {
  const currentPath = useCurrentPath();
  const { value: rootPath } = useRootPath();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const [prevSteps, setPrevSteps] = useState<string[]>([]);
  const { value: state } = useFlowState();
  const { value: flow } = useFlow();

  const findPaths = useCallback(async () => {
    try {
      const nextPaths = await findNextPaths(flow, state, rootPath, {
        option: 'stop_before',
        path: currentPath,
      });
      setPrevSteps(nextPaths.filter((path) => !flow[path].hidden?.(state)));
    } catch (e) {
      setError(e as Error);
    } finally {
      setLoading(false);
    }
  }, [currentPath, flow, state, rootPath]);

  useEffect(() => {
    setLoading(true);
    void findPaths();
  }, [findPaths]);

  return { error, loading, prevSteps };
}
